export default "__VITE_ASSET__6pPHuO5W__"